// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sidebar_wrapper__2Mtxv"};